export enum EFirebaseErrorMessage {
  EMAIL_ALREADY_EXISTS = "An account with this email already exists",
  SIGN_IN_CANCELLED = "Sign-in was cancelled",
  POPUP_BLOCKED = "Popup was blocked. Please allow popups and try again",
  ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL = "An account already exists with the same email but different sign-in method",
  OPERATION_NOT_ALLOWED = "Google sign-in is not enabled",
  USER_NOT_FOUND = "No account found with this email address",
  WRONG_PASSWORD = "Invalid password",
  INVALID_EMAIL = "Invalid email address",
  WEAK_PASSWORD = "Password should be at least 6 characters",
  TOO_MANY_REQUESTS = "Too many failed attempts. Please try again later",
  GOOGLE_ACCOUNT_NOT_FOUND = "No account found for this Google login. Please sign up first.",
  AUTHENTICATION_FAILED = "Authentication failed. Please try again",
  SIGN_UP_AGAIN_WITH_WRONG_PASSWORD = "Account email already exists. Please use your original password to sign up again or reset the password if you can’t remember.",
  EXPIRED_ACTION_CODE = "The link has expired. Please request a new one.",
  INVALID_ACTION_CODE = "The link is invalid or has already been used",
  USER_DISABLED = "This account has been disabled.",
}
